import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import { ITabLabelWithCount } from './interfaces';

export const TabLabelWithCount: React.FC<ITabLabelWithCount> = ({
  label,
  count,
}): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography component="span" variant="body2" fontWeight="bold">
        {label}
      </Typography>
      <Chip
        label={count}
        size="small"
        color="light"
        sx={{
          '.Mui-selected &': {
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
          },
        }}
      />
    </Box>
  );
};
